import React from 'react';

export default function DenominationModal({ isOpen, onClose, currentDenomination, onSelectDenomination }) {
  if (!isOpen) {
    return null;
  }

  const denominations = [
    { value: 0.01, label: '1¢' },
    { value: 0.02, label: '2¢' },
    { value: 0.05, label: '5¢' },
    { value: 0.10, label: '10¢' },
    { value: 0.25, label: '25¢' },
    { value: 0.50, label: '50¢' },
    { value: 1.00, label: '$1' }
  ];

  const handleSelect = (value) => {
    onSelectDenomination(value);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '20px',
        borderRadius: '8px',
        maxWidth: '300px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ marginTop: 0 }}>Select Denomination</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '20px' }}>
          {denominations.map(denom => (
            <button
              key={denom.value}
              onClick={() => handleSelect(denom.value)}
              style={{
                padding: '12px',
                fontSize: '16px',
                cursor: 'pointer',
                border: currentDenomination === denom.value ? '2px solid #007bff' : '1px solid #ccc',
                backgroundColor: currentDenomination === denom.value ? '#e7f3ff' : 'white',
                borderRadius: '4px',
                fontWeight: currentDenomination === denom.value ? 'bold' : 'normal'
              }}
            >
              {denom.label}
            </button>
          ))}
        </div>
        <button onClick={onClose} style={{
          padding: '8px 16px',
          backgroundColor: '#f0f0f0',
          border: '1px solid #ccc',
          borderRadius: '4px',
          cursor: 'pointer',
          width: '100%'
        }}>
          Cancel
        </button>
      </div>
    </div>
  );
}
